import { useAuth } from '@clerk/react'
import {
  SignInButton,
  SignUpButton,
  UserButton,
} from '@clerk/react'
import { Button, Group } from '@mantine/core'
import { IconLogin, IconUserPlus } from '@tabler/icons-react'

function AuthButton({ size = 'md' }) {
  const { isSignedIn, isLoaded } = useAuth()

  if (!isLoaded) return null

  if (isSignedIn) {
    return <UserButton afterSignOutUrl="/" />
  }

  return (
    <Group gap="sm">
      <SignInButton mode="modal">
        <Button
          variant="subtle"
          size={size}
          leftSection={<IconLogin size={16} />}
        >
          Sign In
        </Button>
      </SignInButton>
      <SignUpButton mode="modal">
        <Button
          variant="filled"
          size={size}
          leftSection={<IconUserPlus size={16} />}
        >
          Sign Up
        </Button>
      </SignUpButton>
    </Group>
  )
}

export default AuthButton
